import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authenticatedGuard } from './guards/authenticated.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./guest/guest.module').then(m => m.GuestModule),
    pathMatch: 'prefix',
  },
  {
    path: 'panel',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
    pathMatch: 'prefix',
    canActivate: [authenticatedGuard],
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    pathMatch: 'prefix',
    canActivate: [authenticatedGuard],
  }
 ];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
